import { Select } from "antd";
import { useEffect, useState } from "react";
import { getActorTypes } from "../../../../controllers/entities";
import { SizeType } from "antd/es/config-provider/SizeContext";

interface Props {
  onChange: (value: any) => void;
  onClear?: () => void;
  size?: SizeType;
  placeholder?: string;
  mode?: any;
  defaultValue?: string;
  style?: any;
}

const SelectActorType = (props: Props) => {
  const [actorTypes, setActortypes] = useState([]);
  useEffect(() => {
    const getActors = async () => {
      const actors = await getActorTypes();
      setActortypes(
        actors.map((actor: any) => {
          return {
            value: actor.id,
            label: actor.actor,
            collectionName: actor.collection_name,
          };
        })
      );
    };
    getActors();
  }, []);

  return (
    <div style={{ width: "100%" }}>
      <Select
        {...props}
        labelInValue
        allowClear
        placeholder={props?.placeholder || "Actor"}
        onClear={() => {
          if (props.onClear) {
            props?.onClear();
          }
        }}
        size={props.size}
        defaultValue={props?.defaultValue}
        style={props.style}
        onChange={(selected: any) => {
          if (selected) {
            if (Array.isArray(selected)) {
              return props.onChange(
                selected.map((a: any) => {
                  const actor = actorTypes.find(
                    (actor: any) => actor.value === a.value
                  );
                  return actor;
                })
              );
            }

            const value = actorTypes.find(
              (actor: any) => actor.value === selected.value
            );
            props.onChange(value);
          }
        }}
        options={actorTypes}
      />
    </div>
  );
};

export default SelectActorType;
